var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.2V18.4C5 19.2824 5.7176 20 6.6 20H17.8C18.6824 20 19.4 19.2824 19.4 18.4V7.2C19.4 6.3176 18.6824 5.6 17.8 5.6H16.2V4.8C16.2 4.35817 15.8418 4 15.4 4C14.9582 4 14.6 4.35817 14.6 4.8V5.6H9.8V4.8C9.8 4.35817 9.44183 4 9 4C8.55817 4 8.2 4.35817 8.2 4.8V5.6H6.6C5.7176 5.6 5 6.3176 5 7.2ZM17.8008 18.4H6.5992V10.4H17.8008V18.4ZM17.8008 8.8H6.5992V7.2H17.8008V8.8Z",
    fill: "#060606"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/date.b157c218b31457479c2896468fe6dbd9.svg";